KM3D.scenes.palet = function (T, M, KM) {
  var P = Math.PI, root = new T.Group(), W = 1.7;
  function add(m, x, y, z, p) { m.position.set(x, y, z); (p || root).add(m); return m; }
  function cylZ(r, len, mat, seg) { var g = new T.CylinderGeometry(r, r, len, seg || 32); g.rotateX(P / 2); return new T.Mesh(g, mat); }
  var pts = [[-3.55, 0.95], [-3.15, 0.3], [-2.6, 0.04], [0, 0.04], [1.9, 0.06], [3.05, 0.45], [3.6, 1.45], [3.2, 2.35], [2.6, 2.6], [0.4, 2.2], [-2.5, 1.95], [-3.25, 1.6]]
    .map(function (p) { return new T.Vector3(p[0], p[1], 0); });
  var curve = new T.CatmullRomCurve3(pts, true, 'catmullrom', 0.5), LEN = curve.getLength();
  var N = 62, plate = new T.InstancedMesh(new T.BoxGeometry(LEN / N * 0.96, 0.07, W), M.shoe, N);
  var grou = new T.InstancedMesh(new T.BoxGeometry(0.13, 0.11, W * 0.98), M.black, N);
  var pin = new T.InstancedMesh(new T.CylinderGeometry(0.05, 0.05, W + 0.2, 8), M.steel, N);
  var pm = new T.Matrix4(); pin.geometry.rotateX(P / 2);
  root.add(plate); root.add(grou); root.add(pin);
  var d = new T.Object3D(), pp = new T.Vector3(), tt = new T.Vector3();
  // frame
  function rr(w, h, r) { var s = new T.Shape(); s.moveTo(-w + r, -h); s.lineTo(w - r, -h); s.quadraticCurveTo(w, -h, w, -h + r); s.lineTo(w, h - r); s.quadraticCurveTo(w, h, w - r, h); s.lineTo(-w + r, h); s.quadraticCurveTo(-w, h, -w, h - r); s.lineTo(-w, -h + r); s.quadraticCurveTo(-w, -h, -w + r, -h); return s; }
  var fg = new T.ExtrudeGeometry(rr(2.15, 0.38, 0.25), { depth: 0.9, bevelEnabled: true, bevelThickness: 0.06, bevelSize: 0.06, bevelSegments: 2, curveSegments: 6 });
  fg.translate(0, 0, -0.45);
  var frame = add(new T.Mesh(fg, M.yellow), 0.0, 1.2, 0); frame.rotation.z = -0.02;
  var beam = add(new T.Mesh(new T.BoxGeometry(4.2, 0.2, 0.9), M.yellow), 0.0, 1.75, 0); beam.rotation.z = 0.0;
  var rol = [], i;
  for (i = 0; i < 6; i++) {
    var x = -2.1 + i * 0.78, g = new T.Group(); g.position.set(x, 0.46, 0); root.add(g);
    g.add(add(cylZ(0.36, 0.7, M.yellow, 28), 0, 0, 0, g));
    [-1, 1].forEach(function (s) { var fl = cylZ(0.46, 0.08, M.yellow, 28); fl.position.z = s * 0.36; g.add(fl); });
    var hub = cylZ(0.15, 1.0, M.dark, 14); g.add(hub);
    var bolt = cylZ(0.05, 1.05, M.chrome, 8); bolt.position.y = 0.2; g.add(bolt);
    rol.push(g);
  }
  var car = [];
  [-1.0, 1.0].forEach(function (x) {
    var g = new T.Group(); g.position.set(x, 2.35, 0); root.add(g);
    g.add(cylZ(0.24, 0.6, M.yellow, 20)); var h2 = cylZ(0.1, 0.8, M.dark, 12); g.add(h2); car.push(g);
  });
  var idl = new T.Group(); idl.position.set(-2.6, 0.95, 0); root.add(idl);
  idl.add(cylZ(0.8, 0.6, M.yellow, 40)); [-1, 1].forEach(function (s) { var fl = cylZ(0.9, 0.08, M.yellow, 40); fl.position.z = s * 0.34; idl.add(fl); });
  var ih = cylZ(0.28, 0.9, M.dark, 20); idl.add(ih);
  var ib = cylZ(0.5, 0.04, M.steel, 28); ib.position.z = 0.46; idl.add(ib);
  var spr = new T.Group(); spr.position.set(2.6, 1.5, 0); root.add(spr);
  var sg = new T.Mesh(KM.gear(T, { n: 21, ro: 1.08, ri: 0.92, d: 0.34 }), M.shoe); spr.add(sg);
  var sd = cylZ(0.9, 0.5, M.yellow, 40); spr.add(sd); var sh = cylZ(0.3, 0.9, M.chrome, 20); spr.add(sh);
  [-1, 1].forEach(function (s) { var sgg = sg.clone(); sgg.position.z = s * 0.3; spr.add(sgg); });
  spr.remove(sg);
  for (i = 0; i < 6; i++) { var bb = cylZ(0.05, 0.62, M.chrome, 8); var a = i / 6 * P * 2; bb.position.set(Math.cos(a) * 0.6, Math.sin(a) * 0.6, 0); spr.add(bb); }
  add(KM.shadow(T, 10, 4, -0.02, 0.8), 0, -0.02, 0);
  var side = curve.getPointAt(0).y; var sgn = 1;
  function layout(u0) {
    for (var i = 0; i < N; i++) {
      var u = (u0 + i / N) % 1; curve.getPointAt(u, pp); curve.getTangentAt(u, tt);
      var ang = Math.atan2(tt.y, tt.x); d.position.copy(pp); d.rotation.set(0, 0, ang); d.updateMatrix(); plate.setMatrixAt(i, d.matrix);
      var nx = tt.y, ny = -tt.x; // clockwise orientation => outward normal
      d.position.set(pp.x + nx * 0.07, pp.y + ny * 0.07, 0); d.updateMatrix(); grou.setMatrixAt(i, d.matrix);
      d.position.copy(pp); d.position.x -= tt.x * LEN / N * 0.5; d.position.y -= tt.y * LEN / N * 0.5; d.updateMatrix(); pin.setMatrixAt(i, d.matrix);
    }
    plate.instanceMatrix.needsUpdate = grou.instanceMatrix.needsUpdate = pin.instanceMatrix.needsUpdate = true;
  }
  function update(t) {
    var v = 1.9, dist = v * t; layout((dist / LEN) % 1);
    rol.forEach(function (g) { g.rotation.z = -dist / 0.46; });
    car.forEach(function (g) { g.rotation.z = -dist / 0.24; });
    idl.rotation.z = -dist / 0.9; spr.rotation.z = -dist / 1.0;
  }
  root.position.set(0, -1.1, 0);
  root.rotation.y = 0;
  return { root: root, update: update, pose: 0.3, cam: { fov: 30, p: [5.5, 4.2, 9.5], l: [0, 0.4, 0] } };
};